import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-[72px] min-h-[calc(100vh-72px)] flex items-center justify-center bg-background-50">
        <div className="text-center px-4 py-20">
          <div className="w-24 h-24 mx-auto flex items-center justify-center bg-primary-50 rounded-full mb-8">
            <i className="ri-emotion-sad-line text-primary-500 text-5xl" style={{ width: '48px', height: '48px' }} />
          </div>
          <h1 className="font-display text-[72px] md:text-[96px] text-primary-500 leading-none">404</h1>
          <p className="mt-4 text-xl font-heading font-semibold text-foreground-900">页面未找到</p>
          <p className="mt-2 text-sm text-foreground-400 max-w-[360px] mx-auto">
            您访问的页面不存在或已被移除，试试返回首页寻找更多精彩漫画吧
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 h-12 px-8 bg-primary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line" style={{ width: '16px', height: '16px' }} />
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}